import { deprecated } from "typesafe-actions";

import type { IShopFeatures } from "@/shop/types/personalized";

import { PersonalizedAreaActions } from "./constants";

const { createStandardAction } = deprecated;

export const detectFeatures = createStandardAction(PersonalizedAreaActions.DETECT_FEATURES)();

export const detectFeaturesStart = createStandardAction(PersonalizedAreaActions.DETECT_FEATURES_START)();

export const detectFeaturesSuccess = createStandardAction(PersonalizedAreaActions.DETECT_FEATURES_SUCCESS).map((payload: IShopFeatures) => ({
  payload
}));

export const detectFeaturesFail = createStandardAction(PersonalizedAreaActions.DETECT_FEATURES_FAIL).map((err: Error) => ({
  payload: err,
  error: true
}));
